/* DSL Checkout-recovery — log "abandoned-checkout" event when user leaves /cart with items */
(function(){
  if (location.pathname !== "/cart") return;
  fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
    if (c.item_count === 0) return;
    addEventListener("pagehide", function(){
      if (window.DSL_AB) window.DSL_AB.track("checkout_abandoned", {value: c.total_price/100, items: c.item_count});
    }, {once: true});
  });
})();